// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608131918/js/" + chunkId + "." + {"44":"b3c6e5c5","225":"cc26a54e","481":"b7f8d3d3","486":"b62ddae4","770":"71434738"}[chunkId] + ".0.3856306328632544.chunk.js";
};